import { Button, Card, Checkbox, Input, Modal, Popover, Slider, Space, Typography } from "antd";
import React, { useContext, useEffect, useState } from "react";
import apiService from "../services/apiServices";
import { AuthContext } from "../context/auth-context/AuthContext";
import ModalSinPortal from "../core/components/ModalSinPortal";
import LoadingSpin from "./loadingSpin";
import copy from 'copy-to-clipboard';

export default function SceneInspector({
  //proyecto,
  escena,
  guardarCambios,
  modo,
  actualizarExperienciaAPI,
  cambiarTabKey,
}) {
  const [isHover, setIsHover] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rotEditing, setRotEditing] = useState(escena.inicio || { x: 0, y: 0 });
  const { handleRefreshToken } = useContext(AuthContext);
  //state que maneja los mensajes del modal sin portal
  const [dataModal, setDataModal] = useState({
    titulo: "",
    mensaje: "",
  });
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const [tituloAux, setTituloAux] = useState(escena.titulo);

  //state que maneja el modal de confirmacion
  const [dataModalConfirmacion, setDataModalConfirmacion] = useState({
    title: "Confirmar",
    open: isModalOpen,
    onOk: () => {},
    onCancel: () => {},
    okText: "Confirmar",
    cancelText: "Cancelar",
    message: "Confirmar Accion",
  });

  const [success, setSuccess] = useState(false);
  const [showModal, setShowModal] = useState(false);
  

  const activarPrincipal = (e) => {
    escena.principal = e.target.checked;
    if (!modo) {      
      setDataModalConfirmacion({
        title: "Confirmar Principal",
        open: true, 
        onOk:()=> {
          guardarCambios(escena,"principal");
          setIsModalOpen(false);
        }, 
        onCancel: cancelarAccion, 
        okText: "Confirmar",
        cancelText: "Cancelar",
        message: "Confirme el cambio de escena principal",
      }); 
      setIsModalOpen(true); 
    }else{
      
      guardarCambios(escena,"principal");
      setIsModalOpen(false);
    }
  };

  //nuevo metodo que maneja la rotacion de la escena
  // const modificarRotacion = (e) => {
    
  // }

  const alCambiarRot = (e) => {
    console.log("alCambiarRot", e);
    setRotEditing({ x: e.x, y: e.y });
    let valorX = (e.x * Math.PI) / 180;
    let valorY = ((e.y * Math.PI) / 180) * -1;

    let camara = document.getElementById("camara");
    camara.components["look-controls"].pitchObject.rotation.x = valorX;
    camara.components["look-controls"].yawObject.rotation.y = valorY;
    escena.inicio = e;
  };

  const eliminarEscena = async () => {
    setIsLoading(true);
    try {
      const tokenVerified = await handleRefreshToken();
      await apiService.deleteSceneById(tokenVerified, escena.id);
      setSuccess(true);
      setDataModal({
        titulo: "Exito",
        mensaje: `Ha eliminado la escena!`,
      });
      setShowModal(true);
      actualizarExperienciaAPI();
      cambiarTabKey(1);
    } catch (error) {
      setSuccess(false);
      setIsLoading(false);
      setDataModal({
        titulo: "Error",
        mensaje: "Ha sucedido un error al eliminar la escena...",
      });
      setShowModal(true);
    } finally {
      setIsLoading(false);
      setIsModalOpen(false);
    }
  };
  

  const mostrarModalConfirmacion = (action) => {
    if(action === "eliminar") {
      setDataModalConfirmacion({
        title: "Confirmar Eliminacion",
        open: true, 
        onOk: eliminarEscena, 
        onCancel: cancelarAccion, 
        okText: "Confirmar",
        cancelText: "Cancelar",
        message: "Confirme la eliminacion de la escena",
      });  
    }
    // else if(action === "principal") {
    //   setDataModalConfirmacion({
    //     title: "Confirmar Principal",
    //     open: true, 
    //     onOk: activarPrincipal, 
    //     onCancel: cancelarAccion, 
    //     okText: "Confirmar",
    //     cancelText: "Cancelar",
    //     message: "Confirme el cambio de escena principal",
    //   });  
    // }
    else {
      return;
    }
    
    setIsModalOpen(true);
    
  };
  
  const cancelarAccion = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    console.log("cambioEscena:", escena);
    let camara = document.getElementById("camara");
    console.log("look", escena.inicio);
    let valorX = (escena.inicio.x * Math.PI) / 180;
    let valorY = ((escena.inicio.y * Math.PI) / 180) * -1;
    if (camara && camara.components && camara.components["look-controls"]) {
      camara.components["look-controls"].pitchObject.rotation.x = valorX;
      camara.components["look-controls"].yawObject.rotation.y = valorY;
    }

    setRotEditing(escena.inicio);
    setTituloAux(escena.titulo);
  }, [escena]);

  const [isCopied, setIsCopied] = useState(false)

  const handleCopyUrl360 = () => {
    const copied = copy(escena.fondo, {
      debug: true,
      message: 'Press to copy',
    });
    if (copied) {
      setIsCopied(true)
      setTimeout(() => {
        setIsCopied(false)
      },2000)
    }

  }

  // Add useEffect to update tituloAux when escena.titulo changes
  useEffect(() => {
    setTituloAux(escena.titulo);
  }, [escena.titulo]);


  return (
    <>
      <Space.Compact style={{ width: '100%', marginBottom: '20px' }}>
      <Input
        style={{
        color: "white",
        backgroundColor: "#071529",
        }}
        value={tituloAux}
        onChange={(e) => setTituloAux(e.target.value)}
      />
      <Button 

        disabled={tituloAux === escena.titulo}
        type="primary" 
        onClick={() => {
          if (tituloAux !== escena.titulo) {
          escena.titulo = tituloAux;
          guardarCambios(escena, "titulo")              
        }
      }}
        
      >
        Guardar
      </Button>
      </Space.Compact>      
      <Card
      title= "Principal: "
      color="white"        
      size="small"
      style={{
        textAlign: "left",
        backgroundColor:"#071529",          
        color: "white",
      }}
      headStyle={{          
        color: "white",
      }}
      >
      <Checkbox
        checked={escena.principal}
        onChange={activarPrincipal}
        disabled={escena.principal}
        style={{ color: "white" }}
      >
        Establecer como Principal
      </Checkbox>
      </Card>
      {/* Rest of the existing code remains the same */}
      <Card
      title="Vista Inicial: "
      size="small"
      style={{
        backgroundColor:"#071529",          
        textAlign: "left",          
      }}
      headStyle={{          
        color: "white",
      }}
      >
      <label style={{color:"white"}}>Eje X</label>
      <Slider          
        onChangeComplete={() => guardarCambios(escena,"origen")}
        defaultValue={0}
        step={0.01}
        max={180}
        min={-180}
        value={rotEditing.x}
        onChange={(v) => alCambiarRot({ ...rotEditing, x: v })}
        disabled={!escena}
      />
      <label style={{color:"white"}}>Eje Y</label>
      <Slider
        onChangeComplete={() => guardarCambios(escena,"origen")}
        defaultValue={0}
        step={0.01}
        max={180}
        min={-180}
        value={rotEditing.y}
        onChange={(v) => alCambiarRot({ ...rotEditing, y: v })}
        disabled={!escena}
      />
      </Card>

      {!modo && (
      <Card style={{ backgroundColor: "#071529", color: "white" }}>
        <Button
        type={isHover ? "primary" : "default"}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        danger
        onClick={() => mostrarModalConfirmacion("eliminar")}
        >
        Eliminar Escena
        </Button>
      </Card>
      )}

      <Typography.Text style={{color: "white",textAlign:'left', display:'block',padding:'0 20px', fontWeight:'bold', marginTop:'20px' }}>Link de Imagen 360</Typography.Text>
      <Space.Compact
      style={{
      width: '100%',
      boxSizing: 'border-box',
      padding: '20px',
      margin: '10px 0',
      }}      
      title="Link de Imagen 360"
    >
      <Input style={{color:"white"}} value={escena.fondo} disabled />
      <Button type="primary" onClick={handleCopyUrl360}>Copiar <Popover title="Link copiado!"  trigger="click"  open={isCopied}></Popover> </Button>
    </Space.Compact>

      <ModalSinPortal
      titulo={dataModal.titulo}
      mensaje={dataModal.mensaje}
      setIsVisible={setShowModal}
      isVisible={showModal}
      success={success}
      />

      <LoadingSpin visible={isLoading} />
      <Modal
       title={dataModalConfirmacion.title}
       open={isModalOpen}
       onOk={dataModalConfirmacion.onOk}
       onCancel={dataModalConfirmacion.onCancel}
       okText={dataModalConfirmacion.okText}
       cancelText={dataModalConfirmacion.cancelText}
      >
      <p>{dataModalConfirmacion.message}</p>
      </Modal>
    </>
    );
}
